import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const ChatMessage = (props: SvgProps) => (
  <Svg width={20} height={12} viewBox="0 0 20 12" fill="none" {...props}>
    <g filter="url(#chatmsg_filter1)">
      <path
        d="M17.35 0H1.6796C0.752034 0 0 0.753774 0 1.68362V8.78727C0 9.71711 0.752034 10.4707 1.6796 10.4707H1.86781L2.67233 11.8675C2.77405 12.0442 3.02838 12.0442 3.1301 11.8675L3.93462 10.4707H17.3498C18.2774 10.4707 19.0294 9.71697 19.0294 8.78727V1.68362C19.0294 0.753909 18.2774 0.00013495 17.3498 0.00013495L17.35 0Z"
        fill="url(#chatmsg_gradient)"
      />
    </g>
    <rect
      x="2.09277"
      y="2.90247"
      width="14.8941"
      height="0.644067"
      rx="0.322034"
      fill="#F5FAD9"
    />
    <rect
      x="2.09277"
      y="4.91516"
      width="14.8941"
      height="0.644067"
      rx="0.322034"
      fill="#F5FAD9"
    />
    <rect
      x="2.09277"
      y="6.92789"
      width="14.8941"
      height="0.644067"
      rx="0.322034"
      fill="#F5FAD9"
    />
    <defs>
      <filter
        id="chatmsg_filter1"
        x="-1.08243"
        y="-1.43121"
        width="21.1942"
        height="14.1528"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1.08243" dy="0.721621" />
        <feGaussianBlur stdDeviation="1.16061" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.701961 0 0 0 0 0.764706 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.08243" dy="-1.44324" />
        <feGaussianBlur stdDeviation="0.715607" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.937255 0 0 0 0 0.0980392 0 0 0 0 0.431373 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow"
          result="effect2_innerShadow"
        />
      </filter>
      <linearGradient
        id="chatmsg_gradient"
        x1="9.51471"
        y1="0"
        x2="9.51471"
        y2="12"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB3C3" />
        <stop offset="1" stopColor="#EF196E" />
      </linearGradient>
    </defs>
  </Svg>
);

export default ChatMessage;
